import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className, y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.7, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, title, intro, className = "" }) => (
  <div className={`max-w-3xl ${className}`}>
    {eyebrow && (
      <Reveal>
        <p className="flex items-center gap-3 font-mono text-xs font-semibold uppercase tracking-[0.25em] text-[#FF6B00]">
          <span className="inline-block h-px w-8 bg-[#FF6B00]" aria-hidden="true" />
          {eyebrow}
        </p>
      </Reveal>
    )}
    <Reveal delay={0.08}>
      <h2 className="mt-4 font-display text-3xl font-black uppercase leading-[1.02] tracking-tight text-white sm:text-4xl lg:text-5xl">
        {title}
      </h2>
    </Reveal>
    {intro && (
      <Reveal delay={0.16}>
        <p className="mt-5 text-base leading-relaxed text-slate-300">{intro}</p>
      </Reveal>
    )}
  </div>
);
